// Port of the legacy @roc/feature-borrowers trackRecordEntityForm, rendered inside a dialog.
import { Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { Button, FileUploadArea, createSelectField, createTextField } from '@roc/ui';
import { stateOptions } from 'libs/client-portal-shared/src/app/modules/bridgePricer/utils/bridgePricerConstants';

interface TrackRecordEntityFormProps {
  store: any;
  onCancel: () => void;
  onSave: () => void;
}

export const TrackRecordEntityForm = observer(({ store, onCancel, onSave }: TrackRecordEntityFormProps) => {
  const formStore = store.trackRecordEntityFormStore;

  return (
    <Grid container direction="row" spacing={2} style={{ padding: 16 }}>
      <Grid item xs={12}>
        <Typography variant="h5">Edit Entity</Typography>
      </Grid>
      <Grid item xs={9}>
        {createTextField({
          store: formStore,
          testId: 'entityName',
          fieldName: 'entityName',
          label: 'Entity Name',
        })}
      </Grid>
      <Grid item xs={3}>
        {createSelectField({
          store: formStore,
          testId: 'entityState',
          fieldName: 'entityState',
          label: 'Entity State',
          options: stateOptions,
        })}
      </Grid>
      <Grid item xs={12}>
        <FileUploadArea
          items={store.currentDocumentsToUpload}
          setItems={(updateFunc) => {
            store.currentDocumentsToUpload = updateFunc(store.currentDocumentsToUpload);
          }}
          multiple
        />
      </Grid>
      <Grid container justifyContent="flex-end" style={{ gap: 8, padding: 8 }}>
        <Button variant="outlined" color="primary" onClick={onCancel} testId="cancelEntity">
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onSave} testId="saveEntity" disabled={store.loading}>
          Save
        </Button>
      </Grid>
    </Grid>
  );
});
